/**
 * ConsentTagManager (Epic 33, Story 33-3).
 *
 * Null-rendering side-effect component mounted at the app root. On mount
 * (client-side only — never SSR/prerender, per ADR-0005 Risk #5) it initializes
 * Consent Mode v2 default-denied (33-5), loads the GTM container (33-3) if
 * provisioned, and loads GA4 (Story 30.17) if provisioned. All idempotent, so
 * StrictMode's double-invoke is harmless.
 */
import { useEffect } from "react";
import { initConsentTagManager } from "../../lib/compliance/gtm";
import { initGa4 } from "../../lib/analytics/ga4";

export function ConsentTagManager(): null {
  useEffect(() => {
    // Consent default-denied is pushed first (inside initConsentTagManager),
    // so GA4 loads cookieless until a CMP grants consent.
    initConsentTagManager();
    initGa4();
  }, []);
  return null;
}
